export default __webpack_public_path__ + "static/media/MAP.00e6a2f7.svg";